import { useEffect, useState } from 'react'

import {
  MORNING_A11Y_CHANGE_EVENT,
  prefersReducedMotion,
} from '@/lib/accessibility'

/** Tracks OS reduced-motion preference and the accessibility panel toggle. */
export function usePrefersReducedMotion(): boolean {
  const [reduced, setReduced] = useState(prefersReducedMotion)

  useEffect(() => {
    const media = window.matchMedia('(prefers-reduced-motion: reduce)')
    const update = () => setReduced(prefersReducedMotion())

    update()
    media.addEventListener('change', update)
    window.addEventListener(MORNING_A11Y_CHANGE_EVENT, update)
    return () => {
      media.removeEventListener('change', update)
      window.removeEventListener(MORNING_A11Y_CHANGE_EVENT, update)
    }
  }, [])

  return reduced
}
